import React from 'react'
import { AuthResponse, AuthError, UserAgentApplication } from 'msal'
import { User } from '@microsoft/microsoft-graph-types'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { AuthTypes, AuthState } from '../../store/auth/types'
import { updateSession } from '../../store/auth/actions'
import MicrosoftLogin from 'react-microsoft-login'

const SignInButton: React.FC<AppProps> = ({ updateSession }) =>
  <MicrosoftLogin
    clientId="aec83053-579c-4646-812e-cfa7d97ad9a0"
    authCallback={(err: AuthError | null, data?: AuthResponse | (AuthResponse & User), instance?: UserAgentApplication) => {
      if (data && instance) {
        updateSession({
          id_token: data.idToken.rawIdToken,
          msAuthInstance: instance,
          userEmail: data.idToken.preferredName,
          userName: data.idToken.name
        })
      } else {
        console.log(err, data)
      }
    }}
    redirectUri="https://hero-of-the-day.tools.moia-group.io/"
    tenantUrl="https://login.microsoftonline.com/cb274b49-0c66-429f-a80f-d566b3b24b4c"
/>

interface AppProps {
  updateSession: typeof updateSession
}

const mapDispatchToProps = (dispatch: Dispatch<AuthTypes>): AppProps => ({
  updateSession: (authState: AuthState) => dispatch(updateSession(authState))
})

export default connect(undefined, mapDispatchToProps)(SignInButton)
